/**
 * Scripts
 *
 */

document.addEventListener("DOMContentLoaded", initialize);

function initialize() {
  fixHeader();
  toggleModalVideo();
}

/**
 * Fix Header when scroll
 *
 */
function fixHeader() {
  const header = document.getElementById("header");

  function handler(entries, observer) {
    for (let entry of entries) {
      if (entry.isIntersecting) {
        header.classList.remove("fixed");
      } else {
        header.classList.add("fixed");
      }
    }
  }

  const observer = new IntersectionObserver(handler);
  observer.observe(document.getElementsByClassName("menu-aux")[0]);
}

/**
 * Open Modal Video
 *
 */
function toggleModalVideo() {
  const modal = document.getElementById("js-md");
  const modalWrap = document.querySelectorAll(".js-md-wrap");
  const modalClose = document.querySelectorAll(".js-md-close");
  const modalOpen = document.getElementById("js-md-open");
  const modalVideo = document.getElementById("video-case-vli");

  if (modal !== null) {
    modalWrap.forEach(function (item) {
      item.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          if (e.target == item) {
            e.stopPropagation();
            modal.style.display = "none";
            modalVideo.contentWindow.postMessage(
              '{"event":"command","func":"stopVideo","args":""}',
              "*"
            );
          }
        },
        false
      );
    });

    modalClose.forEach(function (item) {
      item.addEventListener(
        "click",
        function (e) {
          e.preventDefault();
          modal.style.display = "none";
          modalVideo.contentWindow.postMessage(
            '{"event":"command","func":"stopVideo","args":""}',
            "*"
          );
        },
        false
      );
    });

    modalOpen.addEventListener(
      "click",
      function (e) {
        e.preventDefault();
        modal.style.display = "block";
      },
      false
    );
  }
}

/**
 * Form validation
 */

$(function () {
  $(".form").validate({
    rules: {
      name: "required",
      email: {
        required: true,
        email: true,
      },
      enterprise: "required",
      jobRole: "required",
    },
    messages: {
      name: "Obrigatório",
      enterprise: "Obrigatório",
      jobRole: "Obrigatório",
      email: "E-mail inválido",
    },
    submitHandler: function (form) {
      $(".form__button").on("click", (e) => {
        e.preventDefault();

        const unindexedArray = $(".form").serializeArray();
        const indexedArray = {};

        $.map(unindexedArray, function (n, i) {
          indexedArray[n["name"]] = n["value"];
        });

        window.axios
          .post(
            "https://xi83rr2nij.execute-api.us-east-1.amazonaws.com/default/register-leads",
            {
              name: indexedArray.name,
              email: indexedArray.email,
              enterprise: indexedArray.enterprise,
              jobRole: indexedArray.jobRole,
            }
          )
          .then((res) => {
            document.querySelector(".download-link").click();
            $("#send").attr("disabled", true);
            $("#send").addClass("success");
            $("#send").text("Cadastrado com Sucesso!");
          })
          .catch((err) => {
            $("#send").attr("disabled", true);
            $("#send").addClass("error");
            $("#send").text("Download indisponível");
          });
      });
    },
  });
});
